<div *ngIf="isLoading; else cardList">
  <umkt-loading [isLoading]="isLoading"></umkt-loading>
</div>

<ng-template #cardList>
  <div class="credit-card-list">
    <label for="new-card" class="credit-card-label">
      <input
        type="radio"
        id="new-card"
        name="credit-card"
        class="radio-input-styled" 
        value="new"
        (change)="onCardSelected('new')"
      />
      <div class="new-card">
        <div class="card-icon credit-card"></div>
        <span class="card-label">{{'components.creditCardList.newCreditCard' | i18n}}</span>
      </div>
    </label>
    <div *ngFor="let card of cardItems" >
      <label [for]="'card-' + card.id" class="credit-card-label">
        <input
          type="radio"
          name="credit-card"
          [id]="'card-' + card.id"
          [checked]="card.token === selectedCardToken"
          class="radio-input-styled" 
          [value]="card.id"
          (change)="onCardSelected(card.token)"
        />
        <umkt-credit-card-item
          [cardFlag]="card.cardFlag"
          [lastFourDigits]="card.lastFourDigits"
        ></umkt-credit-card-item>
      </label>
    </div>
  </div>
</ng-template>
